import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../Firebase";
import usePwaInstallPrompt from "../../hooks/usePwaInstallPrompt";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { isInstallable, promptInstall } = usePwaInstallPrompt();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch {
      setError("Invalid login credentials");
    }
  };

  return (
    <div className="admin-login">
      {isInstallable && (
        <div className="pwa-install-banner">
          <span>Install Crowned Admin for faster access</span>
          <button type="button" onClick={promptInstall}>
            Install
          </button>
        </div>
      )}

      <h1>Admin Login</h1>

      {error && <p className="error">{error}</p>}

      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Sign In</button>
      </form>
    </div>
  );
}
